/* global Switchery */
(function ($) {
    'use strict';
    $.widget("fd.control_toggle", {
        options: {
            parentid: null,
            callback: function () { },
            disabled: false,
            size: 'default',
            color: undefined
        },
        enable: function () {
            this.options.disabled = false;
            this._enable();
        },
        _enable: function () {
            $(this._switcheryInstance.switcher).removeClass("disabled");
            this._switcheryInstance.enable();
            this.element.control_toggle('destroy').control_toggle(this.options);
        },
        disable: function () {
            this.options.disabled = true;
            this._disable();
        },
        _disable: function () {
            $(this._switcheryInstance.switcher).addClass("disabled");
            this._switcheryInstance.disable();
        },
        value: function (value) {
            if (value === undefined) {
                return this._switcheryInstance.element.checked;
            }
            if (value !== this._switcheryInstance.element.checked) {
                $(this._switcheryInstance.switcher).click();
                return value;
            }
        },
        _create: function () {
            const self = this;
            if (!self.options.parentid) {
                self.options.parentid = self.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            self.element.addClass('js-switch');
            self._switcheryInstance = new Switchery(self.element[0], {
                size: self.options.size,
                color: self.options.color
            });

            // workaround to force toggle to respect disabled <fieldsets> (like we do with select2's)
            const fieldset = self.element.closest('fieldset');
            if (self.options.disabled || fieldset.is('[disabled]')) {
                self._disable();
            }
            if (fieldset.length) {
                fieldset.on('disabled', function (ev) {
                    if (ev.target === ev.currentTarget) {
                        self._disable();
                    }
                }).on('enabled', function (ev) {
                    if (ev.target === ev.currentTarget) {
                        self._enable();
                    }
                });
            }
            self._setEvents();

            self.element[0].changeTo = function (checked) {
                self._changeSwitchery(self.element, checked);
            };
        },
        _changeSwitchery: function (element, checked) {
            if ((element.is(':checked') && checked === false) || (!element.is(':checked') && checked === true)) {
                element.parent().find('.switchery').trigger('click');
            }
        },
        _handleSubmit: function (event) {
            const self = event.data;
            if (self.options.disabled || self.element.closest('fieldset').is('[disabled]')) {
                return;
            }
            self.options.callback.call(self, { parentid: self.options.parentid, value: self.value() }, event);
        },
        _setEvents: function () {
            $(this.element).off('change.fdcontrol_toggle').on('change.fdcontrol_toggle', null, this, this._handleSubmit);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
            if (key === 'disabled') {
                this._refresh();
            }
        },
        _refresh: function () {
            if (this.options.disabled || this.element.closest('fieldset').is('[disabled]')) {
                this._disable();
            } else {
                this._enable();
            }
        },
        _destroy: function () {
            $(this.element).off('change.fdcontrol_toggle');
            this._switcheryInstance.switcher.remove();
            this._switcheryInstance.destroy();
        },
        _switcheryInstance: null
    });
}(jQuery));